

export const FETCH_PRINTER_REQUEST = "FETCH_PRINTER_REQUEST";
export const FETCH_PRINTER_SUCCESS = "FETCH_PRINTER_SUCCESS";
export const FETCH_PRINTER_FAILURE = "FETCH_PRINTER_FAILURE";

export const CREATE_PRINTER_REQUEST = "CREATE_PRINTER_REQUEST";
export const CREATE_PRINTER_SUCCESS = "CREATE_PRINTER_SUCCESS";
export const CREATE_PRINTER_FAILURE = "CREATE_PRINTER_FAILURE";

export const UPDATE_PRINTER_REQUEST = "UPDATE_PRINTER_REQUEST";
export const UPDATE_PRINTER_SUCCESS = "UPDATE_PRINTER_SUCCESS";
export const UPDATE_PRINTER_FAILURE = "UPDATE_PRINTER_FAILURE";

export const DELETE_PRINTER_REQUEST = "DELETE_PRINTER_REQUEST";
export const DELETE_PRINTER_SUCCESS = "DELETE_PRINTER_SUCCESS";
export const DELETE_PRINTER_FAILURE = "DELETE_PRINTER_FAILURE";
